import './Product.css';


export default function Product({product, addToCartClick}) {

    const handleAddToCartClick = event => {
        addToCartClick(event.target.id, 1);
    }

    return (
        <div className="product">
            <div className='imageContainer'>
                <img src={product.imgSrc} alt='Product image.'/>
            </div>
            <h4>{product.productName}</h4>
            <div className='row2'>
                <div className='col1'>
                    <h5>Starting At</h5>
                    <h6>${(product.price / 100)}</h6>
                </div>
                <div className='col2'>
                    <h5>{product.subcategory}</h5>
                </div>
            </div>
            <div className='row3'>
                <button id={product.id} onClick={handleAddToCartClick}>Add to Cart</button>
            </div>
        </div>
    )
}